var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 459,
    viewBox: "0 0 460 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.952 157.257C400.01 148.651 449.363 163.877 457.442 189.411C461.892 203.472 454.99 224.25 452.121 232.696C445.882 251.121 436.332 264.323 429.566 272.279C439.152 275.344 444.386 284.893 442.241 293.057C440.611 299.272 434.886 304.09 427.813 305.206C425.643 309.839 421.107 312.916 416.044 313.174C408.456 313.578 404.117 307.424 403.896 307.093C394.42 310.109 384.687 305.966 381.12 298.365C378.509 292.812 379.453 285.947 383.302 280.517C377.871 275.54 376.523 267.817 379.6 262.288C383.424 255.411 393.685 252.739 401.604 258.047C406.814 251.672 414.022 241.253 418.705 226.886C421.965 216.858 424.822 207.64 422.174 201.314C416.069 186.788 379.44 184.839 332.404 195.111C333.912 182.485 335.432 169.859 336.94 157.232L336.952 157.257Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.522 267.996C393.307 269.369 395.329 273.316 394.802 278.624C394.214 284.471 390.916 288.173 389.862 289.252",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M392.522 267.996C393.307 269.369 395.329 273.316 394.802 278.624C394.214 284.471 390.916 288.173 389.862 289.252",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.273 285.857L427.821 305.225",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M407.712 285.857L403.912 307.126",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M383.308 280.552L392.367 278.652",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.1 187.498C134.497 238.101 88.7974 262.152 65.0403 249.771C51.9604 242.943 42.1903 223.354 38.2553 215.361C29.6743 197.905 27.1123 181.81 26.291 171.402C17.33 175.999 6.89795 172.922 2.64423 165.628C-0.592041 160.088 0.057663 152.622 4.28687 146.836C2.55841 142.018 3.60037 136.649 6.996 132.886C12.0956 127.247 19.4998 128.534 19.892 128.608C24.4645 119.781 34.2959 115.846 42.1904 118.715C47.9642 120.811 52.1443 126.327 53.2353 132.898C60.6027 132.592 67.0017 137.115 68.7179 143.195C70.8631 150.771 65.4816 159.904 56.1161 161.73C56.9252 169.919 59.1685 182.386 65.9965 195.883C70.7651 205.285 75.2394 213.841 81.5894 216.44C96.1648 222.422 123.489 197.954 149.551 157.476C157.396 167.492 165.23 177.495 173.075 187.51L173.1 187.498Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5649 148.263C54.0449 147.846 49.8157 146.473 46.4446 142.342C42.7302 137.794 42.4605 132.829 42.436 131.321",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5649 148.263C54.0449 147.846 49.8157 146.473 46.4446 142.342C42.7302 137.794 42.4605 132.829 42.436 131.321",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1821 157.342L4.28982 146.836",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2217 146.333L19.9018 128.595",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2305 132.895L48.1554 140.63",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.853 259.283C205.154 312.068 171.467 364.841 137.768 417.627C138.492 421.353 139.043 426.796 137.768 433.085C134.863 447.513 124.578 455.8 121.342 458.202C95.7338 428.414 70.1379 398.626 44.5298 368.825C45.9763 364.339 51.3578 349.579 63.8492 345.154C80.5331 339.245 106.215 353.061 117.468 383.315C150.812 332.258 184.155 281.201 217.498 230.132C224.608 239.841 231.73 249.562 238.84 259.27L238.853 259.283Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M257.683 281.795C236.292 315.077 236.709 346.446 250.119 356.339C251.836 357.614 260.282 363.314 278.939 357.222C279.221 351.815 280.827 347.905 281.955 345.674C282.936 343.749 287.68 334.408 295.304 333.783C295.304 333.783 298.516 333.71 302.12 335.487C319.491 344.031 315.923 432.967 314.685 458.195H245.118C240.202 443.706 243.745 429.547 252.853 423.418C257.462 420.316 262.66 419.838 266.472 420.034C269.096 410.215 271.719 400.384 274.342 390.565C266.607 391.288 239.013 392.943 220.907 375.131C197.113 351.717 197.126 301.96 231.119 262.365C239.969 268.85 248.82 275.322 257.671 281.807L257.683 281.795Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M241.533 321.853L216.697 283.251L228.478 265.574L249.992 287.921L241.533 321.853Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.027 292.111L232.657 268.305L231.026 236.604L208.605 233.993L177.027 292.111Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M288.855 209.177C312.158 249.324 353.384 261.779 377.031 248.012C392.354 239.088 402.381 217.966 398.054 200.4C391.864 175.282 355.799 155.374 313.458 167.4C305.257 181.326 297.056 195.251 288.855 209.177Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M319.922 161.804C365.782 168.975 401.417 144.789 405.61 117.734C408.331 100.217 398.218 79.1199 381.853 71.4338C358.451 60.4256 320.266 75.9205 302.957 116.386C308.608 131.525 314.271 146.665 319.922 161.804Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M302.187 109.168C336.426 77.8227 339.784 34.8932 321.274 14.7278C309.285 1.66017 286.496 -3.61101 270.266 4.36932C247.061 15.782 235.317 55.2669 256.12 94.0653C271.48 99.1035 286.84 104.142 302.187 109.168Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248.359 83.1998C240.686 37.414 206.496 11.242 179.503 15.8022C162.022 18.7565 145.191 34.9991 143.058 52.9579C140.006 78.6396 166.742 109.985 210.615 113.638C223.193 103.488 235.782 93.3499 248.359 83.1998Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.995 124.125C165.653 94.0422 122.626 96.028 104.912 116.892C93.438 130.413 91.023 153.668 100.952 168.783C115.148 190.394 155.797 197.161 191.715 171.712C194.804 155.85 197.905 139.987 200.995 124.125Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M199.605 178.479C153.378 182.634 124.656 214.727 127.144 241.99C128.75 259.642 143.669 277.663 161.407 281.169C186.782 286.17 220.077 261.91 227.064 218.441C217.907 205.116 208.75 191.804 199.605 178.479Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M235.632 211.51C211.924 251.412 221.118 293.483 244.679 307.434C259.928 316.468 283.269 314.936 296.496 302.604C315.411 284.964 315.239 243.775 284.102 212.65C267.946 212.27 251.789 211.89 235.632 211.51Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M253.282 226.891C214.827 226.891 183.653 195.717 183.653 157.262C183.653 118.808 214.827 87.6338 253.282 87.6338C291.737 87.6338 322.911 118.808 322.911 157.262C322.911 195.717 291.737 226.891 253.282 226.891Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 141.792C164.456 123.776 179.061 109.172 197.076 109.172C215.092 109.172 229.696 123.776 229.696 141.792V147.688C229.696 165.704 215.092 180.308 197.076 180.308C179.061 180.308 164.456 165.704 164.456 147.688V141.792Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.914 163.781C185.803 163.781 179.228 154.434 179.228 142.905C179.228 131.375 185.803 122.028 193.914 122.028C202.025 122.028 208.6 131.375 208.6 142.905C208.6 154.434 202.025 163.781 193.914 163.781Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.88 115.736L193.278 132.236L212.438 129.098L198.88 115.736Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.526 143.585C219.526 125.569 234.131 110.965 252.146 110.965C270.162 110.965 284.766 125.569 284.766 143.585V149.481C284.766 167.497 270.162 182.101 252.146 182.101C234.131 182.101 219.526 167.497 219.526 149.481V143.585Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M248.99 165.6C240.879 165.6 234.304 156.254 234.304 144.724C234.304 133.194 240.879 123.848 248.99 123.848C257.1 123.848 263.675 133.194 263.675 144.724C263.675 156.254 257.1 165.6 248.99 165.6Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M253.962 117.556L248.359 134.068L267.52 130.918L253.962 117.556Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M268.737 101.073L243.519 96.4805C238.457 95.5588 235.1 90.7079 236.022 85.6457L236.343 83.8849C237.264 78.8228 242.115 75.4664 247.177 76.3882L272.395 80.9801C277.458 81.9019 280.814 86.7528 279.892 91.8149L279.572 93.5757C278.65 98.6379 273.799 101.994 268.737 101.073Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M175.72 82.0208L200.938 77.4288C206 76.507 210.851 79.8634 211.773 84.9256L212.093 86.6864C213.015 91.7485 209.658 96.5994 204.596 97.5212L179.378 102.113C174.316 103.035 169.465 99.6785 168.544 94.6164L168.223 92.8556C167.301 87.7934 170.658 82.9425 175.72 82.0208Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.221 202.251C230.044 205.499 236.529 205.536 240.709 202.251C242.707 200.682 243.798 198.659 244.387 197.065",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M266.483 420.033C269.008 420.622 272.306 421.688 275.812 423.686C277.908 424.875 279.636 426.15 281.034 427.339L272.33 398.103L266.471 420.045L266.483 420.033Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg2);
export default __webpack_public_path__ + "static/media/footerImg2.c9cf78a4fa3b9d60c50c8063468ef7b3.svg";
export { ForwardRef as ReactComponent };